import { useEffect, useState } from 'react';

import getMetadata from '@/shared/api/inventory/getMetadata';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';
import Metadata from '@/shared/types/metadata/index.type';

type Args = {
  refetchMetadata?: boolean;
  setRefetchMetadata?: (value: boolean) => void;
};

const useFetchInventoryMetadata = ({
  refetchMetadata,
  setRefetchMetadata,
}: Args = {}) => {
  const redirectLogin = useRedirectLogin();

  const [isFirstFetchMetadata, setIsFirstFetchMetadata] = useState(true);
  const [metadata, setMetadata] = useState<Metadata | null>(null);
  const [isFetching, setIsFetching] = useState(false);
  const [fetchError, setFetchError] = useState('');

  useEffect(() => {
    const fetchInventoryMetadata = async () => {
      setIsFetching(true);

      const response = await getMetadata(() => redirectLogin());

      if (response.success) {
        setMetadata(response.data);
        setIsFetching(false);
      } else {
        setIsFetching(false);
        setFetchError(response.msg);
      }
    };

    if (isFirstFetchMetadata) {
      setIsFirstFetchMetadata(false);
      void fetchInventoryMetadata();
    }

    if (refetchMetadata) {
      setRefetchMetadata?.(false);
      void fetchInventoryMetadata();
    }
  }, [
    isFirstFetchMetadata,
    refetchMetadata,
    redirectLogin,
    setRefetchMetadata,
  ]);

  return {
    metadata,
    fetchError,
    isFetching,
  };
};

export default useFetchInventoryMetadata;
